<template>
    <div>
        <el-card>
            <div class="flex justify-between">
                <div class="font-bold" style="font-size: 18px;">筛选条件</div>
                <div class="flex items-center gap-x-3">
                    <CountrySelector v-model="country" @change="init"></CountrySelector>
                    <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="init">
                    </el-date-picker>
                </div>
            </div>
            <el-row :gutter="20" class="mt-5">
                <el-col :span="8">
                    <el-card>
                        <div class="name">总帖子数</div>
                        <div class="number">{{ statData.totalPost || 0 }}</div>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card>
                        <div class="name">日新增帖子数</div>
                        <div class="number">{{ statData.dailyNewPost || 0 }}</div>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card>
                        <div class="name">日评论数</div>
                        <div class="number">{{ statData.dailyNewComment || 0 }}</div>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="mt-5">
            <div id="communityChart" style="width: 100%; height: 400px;"></div>
        </el-card>
        <el-card class="mt-5">
            <div class="font-bold" style="font-size: 18px;">详细数据</div>
            <el-table :data="tableData" style="width: 100%;">
                <el-table-column label="日期" prop="day"></el-table-column>
                <el-table-column label="新增帖子数量" prop="dailyNewPost"></el-table-column>
                <el-table-column label="新增评论数量" prop="dailyNewComment"></el-table-column>
            </el-table>
            <el-pagination class="mt-5" v-model="page" :page-size="10" :total="1" style="text-align: right;"
                @current-change="getTableData"></el-pagination>
        </el-card>
    </div>
</template>

<script>
import CountrySelector from '@/components/CountrySelector.vue';
import { communityNumStats, communityTrend, communityStatList } from '@/api/statistics/community';
import * as echarts from 'echarts';
import dayjs from 'dayjs';

const getThisWeek = () => {
    const today = dayjs();
    const dayOfWeek = today.day();
    const monday = today.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'day').format('YYYY-MM-DD 00:00:00');
    const sunday = today.add(dayOfWeek === 0 ? 0 : 7 - dayOfWeek, 'day').format('YYYY-MM-DD 23:59:59');
    return [monday, sunday];
};

export default {
    components: { CountrySelector },
    data() {
        return {
            country: '',
            date: getThisWeek(),
            communityChart: null,
            tableData: [],
            statData: {},
            page: 1,
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        // 设置本周第一天（周一）
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() - 1));
                        // 设置本周最后一天（周日）
                        end.setTime(end.getTime() + 3600 * 1000 * 24 * (7 - end.getDay()));
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        // 设置本月第一天
                        start.setDate(1);
                        // 设置本月最后一天
                        const year = end.getFullYear();
                        const month = end.getMonth() + 1;
                        const lastDay = new Date(year, month, 0).getDate();
                        end.setDate(lastDay);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.communityNumStats();
            this.communityStatList();
            this.communityTrend();
        },
        communityTrend() {
            communityTrend({
                country: this.country,
                startTime: this.date && this.date[0] ? dayjs(this.date[0]).format('YYYY-MM-DD 00:00:00') : null,
                endTime: this.date && this.date[1] ? dayjs(this.date[1]).format('YYYY-MM-DD 23:59:59') : null
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.initCommunityChart(result)
                } else {
                    this.$message.error(message);
                }
            })
        },
        communityStatList() {
            communityStatList({
                country: this.country,
                startTime: this.date && this.date[0] ? dayjs(this.date[0]).format('YYYY-MM-DD 00:00:00') : null,
                endTime: this.date && this.date[1] ? dayjs(this.date[1]).format('YYYY-MM-DD 23:59:59') : null
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.tableData = result.records;
                } else {
                    this.$message.error(message);
                }
            })
        },
        communityNumStats() {
            communityNumStats().then(({ code, result, message }) => {
                if (code === 200) {
                    this.statData = result;
                } else {
                    this.$message.error(message);
                }
            })
        },
        initCommunityChart(data) {
            const xData = data.map(x => x.day);
            const y1Data = data.map(x => x.dailyNewPost);
            const y2Data = data.map(x => x.dailyNewComment);
            this.communityChart = echarts.init(document.getElementById('communityChart'));
            this.communityChart.setOption({
                title: { text: '帖子与评论趋势' },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['新增用户', '活跃用户'],
                    right: 0
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '新增用户',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(58, 77, 233, 0.8)' },
                                { offset: 1, color: 'rgba(58, 77, 233, 0.1)' }
                            ])
                        },
                        smooth: true,
                        data: y1Data
                    },
                    {
                        name: '活跃用户',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(46, 204, 113, 0.8)' },
                                { offset: 1, color: 'rgba(46, 204, 113, 0.1)' }
                            ])
                        },

                        smooth: true,
                        data: y2Data
                    },
                ]
            });
        }
    }
}
</script>

<style lang="less" scoped>
.name {
    font-size: 14px;
    color: #999;
}

.number {
    font-size: 24px;
    font-weight: bold;
}
</style>